<template>
  <div class="product-container animate__animated animate__fadeIn animate__faster" :class="customBoxClass" @click="goDetail">
    <img class="img" :src="item.cover" alt="">
    <div class="right">
      <div class="title text-ellipsis-1">{{ item.relationName || '' }}</div>
      <div class="desc">{{ item.enterpriseName || '' }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'common-product-item',
  props: {
    type: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      default: () => ({})
    },

    customBoxClass: {
      type: String,
      default: 'mt-11', // 空格分割的class列表，例如 "class1 class2"
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {
    goDetail() {
      // /mini-h5/index/productDetail?language=CN&enterpriseCode=EN1791366099812544512&productCode=PO1801151394183417856&shareUserType=USER&shareUid=1760571616389025792&shareEnCode=
      let language = sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : ''
      let query = {
        language: language || '',
        enterpriseCode: this.item.enterpriseCode || '',
        productCode: this.item.relationId,
        shareUserType: '',
        shareUid: '',
        shareEnCode: '',
      }
      this.$router.push({
         path: `productDetail`,
         query,
      })
    },
  },
  mounted() { }
}
</script>
<style lang="less" scoped>
.mt-11 {
  margin-top: 11px;
}

.mx-12 {
  margin-left: 12px;
  margin-right: 12px;
}

.product-container {
  display: flex;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;

  .img {
    width: 60px;
    height: 60px;
    background-color: #f5f5f5;
    border-radius: 10px;
    flex-shrink: 0;
    margin-right: 10px;
    object-fit: cover;
  }

  .right {
    .title {
      font-size: 15px;
      color: #262626;
      font-weight: 700;
    }

    .desc {
      margin-top: 5px;
      font-size: 12px;
      color: #8C8C8C;
    }
  }
}</style>